import { render } from "./terms-of-service.vue?vue&type=template&id=09a41cfa&ts=true"
import script from "./terms-of-service.vue?vue&type=script&lang=ts"
export * from "./terms-of-service.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__